import axios from 'axios';
import { primeRoutes } from '../deployment/subsystemData';
import type { SsoDomainDto } from '../dto/ssoDomainDto';

const ofSsoDomain = (rootUrl: string) => {
  if (rootUrl.endsWith('/')) {
    // Remove trailing slash to avoid double slashes in the URL path
    // since primeRoutes.ssoDomain starts with a leading slash
    return rootUrl.slice(0, -1) + primeRoutes.ssoDomain;
  }

  return rootUrl + primeRoutes.ssoDomain;
};

const SSO_DOMAIN_TIMEOUT_MS = 30000;

export async function fetchSsoDomain(
  rootUrl: string,
  orgName: string | undefined,
  domain: string | undefined,
): Promise<SsoDomainDto | undefined> {
  const ssoDomainUrl = ofSsoDomain(String(rootUrl));
  try {
    const response = await axios.get<SsoDomainDto>(ssoDomainUrl, {
      timeout: SSO_DOMAIN_TIMEOUT_MS,
      params: {
        organizationName: orgName,
        domain: domain,
      },
    });
    return response.data;
  } catch (err: any) {
    console.error(`Could not load SSO domains from ${ssoDomainUrl}`, err);
  }
}
